<script setup lang="ts">

import {CurrencyDisplay, formatting, Models, useLocalization, useOrderViewContext} from "@hantera/portal-app";
import {computed} from "vue";
import Decimal from "decimal.js";

const props = defineProps<{
  orderLine: Models.Graph.OrderLine
}>();

const t = useLocalization('components.order.orderLine.details');
const orderViewContext = useOrderViewContext();

const discounted = computed(() => {
  if (props.orderLine.calculatedDiscounts.length === 0) return new Decimal(0);
  
  return Decimal.sum(...props.orderLine.calculatedDiscounts.map(r => r.value)).neg();
});

const orderLineTotal = computed(() => {
  // Order line total is displayed without regards to refunds, as they are shown separately in the breakdown
  return props.orderLine.unitPrice.mul(props.orderLine.quantity).add(discounted.value);
})
</script>

<template>
  <div class="detail">
    <div class="detail-label detail-unit-price">{{ t('unitPrice') }}</div>
    <div class="detail-value detail-unit-price">
      {{ formatting.currency(props.orderLine.unitPrice, orderViewContext.state.currencyCode, CurrencyDisplay.none) }}
    </div>
  </div>
  <div class="detail">
    <div class="detail-label detail-quantity">{{ t('ordered') }}</div>
    <div class="detail-value detail-quantity">
      {{ formatting.number(props.orderLine.quantity) }}
    </div>
  </div>
  <div class="detail">
    <div class="detail-label detail-returned">{{ t('returned') }}</div>
    <div class="detail-value detail-returned">
      {{ formatting.number(props.orderLine.returnedQuantity) }}
    </div>
  </div>
  <div class="detail">
    <div class="detail-label detail-discount">{{ t('discount') }}</div>
    <div class="detail-value detail-discount">
      {{ formatting.currency(discounted, orderViewContext.state.currencyCode, CurrencyDisplay.none) }}
    </div>
  </div>
  <div class="detail" style="grid-column: calc(var(--grid-column-offset) - 3)">
    <div class="detail-label detail-sum">{{ t('sum') }}</div>
    <div class="detail-value detail-sum">
      {{ formatting.currency(orderLineTotal, orderViewContext.state.currencyCode, CurrencyDisplay.none) }}
    </div>
  </div>
</template>

<style scoped>

</style>